import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const LifeInsuranceIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M2 36.1s4.6-4.6 9.1-3.6c4.6.9 7.3 1.8 10.9 1.8h6.4s4.6.9 5.5.9c.9 0 2.7 0 4.6-.9 1.8-.9 3.6-3.6 5.5-3.6 1.8 0 4.6.9 3.6 3.6-.9 2.7-7.3 8.2-7.3 8.2s-3.6 4.6-8.2 4.6H10.2L2 36.1z"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="m37.6 45.1 9.4-9.4c.6-.6.9-1.4.9-2.3 0-.9-.3-1.7-.9-2.3-1.3-1.3-3.3-1.3-4.6 0l-6 6c0 1.8-1.5 3.3-3.4 3.3h-8.6s-.1 0-.1-.1c0 0 0-.1.1-.1H33c1.8 0 3.3-1.5 3.3-3.3 0 0 0 0 0 0 0-1.8-1.5-3.3-3.3-3.3H19.5s0 0 0 0c-1.8-.9-3.5-1.5-6.3-1.5-5 0-9.4 3.6-11.3 5.5l7.3 9.1 7.1.1h16.5c1.9.4 3.6-.3 4.8-1.7l9.4-9.3c.6-.6 1-1.5 1-2.4 0-.9-.3-1.7-1-2.4-1.3-1.3-3.4-1.3-4.8 0l-6 6c-.1-1.8-1.5-3.2-3.4-3.2H19.6c-1.8-.9-3.6-1.5-6.3-1.5-5.1 0-9.1 3.2-11 5.1v.1"
        fill="#ffffff"
        stroke="#000000"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2.1041"
      />
      <path
        d="M11.1 47.1c0 1-.8 1.8-1.8 1.8H3.8c-1 0-1.8-.8-1.8-1.8V32.5c0-1 .8-1.8 1.8-1.8h5.5c1 0 1.8.8 1.8 1.8"
        fill="#ffffff"
        stroke="#000000"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2.1041"
      />
      <path
        d="M10.4 32v16.9"
        fill="#ffffff"
        stroke="#000000"
        className={classnames(styles.white, styles.defaultStrokeColor)}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.7213"
      />
      <path
        d="M13.3 13.4h7.6l2.8-7.1 2.9 12.8 3.6-8.5 2.1 4.2 1.4-1.4h5.8"
        fill="#ffffff"
        className={styles.white}
      />
      <path
        d="M26.6 20s-.1 0 0 0c-.4 0-.7-.3-.8-.7L23.5 9.1l-1.8 4.6c-.1.3-.4.5-.8.5h-7.6c-.5 0-.8-.4-.8-.8s.4-.8.8-.8h7L23 6c.1-.3.5-.6.8-.5.4 0 .7.3.7.6l2.3 10.2 2.5-6.1c.1-.3.4-.5.7-.5.3 0 .6.2.8.5l1.6 3.2.6-.6c.2-.2.4-.2.6-.2h5.8c.5 0 .8.4.8.8s-.4.8-.8.8h-5.5l-1.2 1.2c-.2.2-.5.3-.7.2-.3 0-.5-.2-.6-.5l-1.3-2.6-2.9 6.9c0 .4-.3.6-.6.6z"
        fill="#E81C30"
        className={styles.accentColor}
      />
      <path
        d="M39.4 14c.8-1.3 1.3-2.8 1.3-4.5 0-4.7-3.8-8.5-8.5-8.5-2.2 0-4.2.9-5.7 2.3C25 1.9 22.9 1 20.7 1c-4.7 0-8.5 3.8-8.5 8.5 0 1.6.5 3.2 1.3 4.5h0c1.9 2.3 0 0 2.1 2.6l10.1 10.8 9.2-8.8c2.1-1.8 3.8-3.5 4.5-4.6h0z"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
    </Icon>
  )
}
